module.exports = __webpack_public_path__ + "static/media/onboarding_pin.719a6fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/onboarding_pin.png
// module id = 1097
// module chunks = 0